import pagination from "../static/pagination";

export default {
    setListPembayaran: (state, payload) => {
        state.listPembayaran = payload;
    },
    resetListSettlementEdc: (state) => {
        state.listSettlementEdc = [];
        state.totalSettlementEdc = "";
    },
    setListSettlementEdc: (state, payload) => {
        state.listSettlementEdc = state.listSettlementEdc.concat(payload.list);
        state.totalSettlementEdc = payload.length;
    },
    setSelectedPembayaran: (state, payload) => {
        state.selectedPembayaran = [];
        payload.forEach((data, idx) => {
            let selected = {
                dataIndex: idx,
                items: [],
            };

            // data.list_riwayat_pembayaran.forEach((item) => {
            //     selected.items.push({ idbayar: item.idbayar, nominal: item.nominal });
            // });

            state.selectedPembayaran.push(selected);
        });
    },
	toggleSelectAllPembayaran(state, isSelectAll) {
		if (isSelectAll) {
			state.selectedPembayaran = [];
			state.listPembayaran.forEach((data, idx) => {
				let selected = {
					dataIndex: idx,
					items: [],
				};
	
				data.list_riwayat_pembayaran.forEach((item) => {
					selected.items.push({ idbayar: item.idbayar, nominal: item.nominal });
				});
				state.selectedPembayaran.push(selected);
			});
		} else {
			state.selectedPembayaran = state.selectedPembayaran.map(v => {
				return {
					dataIndex: v.dataIndex,
					items: []
				}
			})
		}
	},
    toggleItem: (state, { idx, data }) => {
        let targetItem = state.selectedPembayaran[idx].items;
        let targetIdx = targetItem.findIndex((target) => target.idbayar === data.idbayar);

        if (targetIdx === -1) {
            targetItem.push(data);
        } else {
            targetItem.splice(targetIdx, 1);
        }

        state.selectedPembayaran[idx].items = targetItem;
    },
    toggleCheckParent: (state, { idx, data, status }) => {
        if (status === "checkAll") {
            state.selectedPembayaran[idx].items = [];
        } else {
            let selected = [];
            data.forEach((item) => {
                selected.push({ idbayar: item.idbayar, nominal: item.nominal });
            });
            state.selectedPembayaran[idx].items = selected;
        }
    },
    setDetailSettlementEdc: (state, payload) => {
        state.detailSettlementEdc = payload;
    },
    resetPaginationSettlement: (state) => {
        state.paginationSettlement = pagination();
    },
    setNextPaginationSettlement: (state, payload) => {
        state.paginationSettlement.length += payload.length;
        state.paginationSettlement.pageNumber++;
        state.paginationSettlement.offset = state.paginationSettlement.pageNumber * state.paginationSettlement.limit;
    },
};
